namespace TabAurous.ECommerce {
    export namespace ECommSalesGiftVoucherService {
        export const baseUrl = 'ECommerce/ECommSalesGiftVoucher';

        export declare function Create(request: Serenity.SaveRequest<ECommSalesGiftVoucherRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ECommSalesGiftVoucherRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ECommSalesGiftVoucherRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ECommSalesGiftVoucherRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ECommerce/ECommSalesGiftVoucher/Create",
            Update = "ECommerce/ECommSalesGiftVoucher/Update",
            Delete = "ECommerce/ECommSalesGiftVoucher/Delete",
            Retrieve = "ECommerce/ECommSalesGiftVoucher/Retrieve",
            List = "ECommerce/ECommSalesGiftVoucher/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ECommSalesGiftVoucherService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
